import { apiSlice } from "../apiSlice";

export const creserxxApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    createSerie: builder.mutation({
      query: (parameters) => ({
        url: `series`,
        method: "POST",
        body: parameters,
      }),
    }),
    updateSerie: builder.mutation({
      query: (parameters) => ({
        url: `/series/${parameters.SERIEIDX}`,
        method: "PUT",
        body: parameters,
      }),
    }),
    createCompanyAreaSerie: builder.mutation({
      query: (parameters) => ({
        url: `areasxseries`,
        method: "POST",
        body: parameters,
      }),
      invalidatesTags: ["reloadTable"],
    }),
    updateCompanyAreaSerie: builder.mutation({
      query: (parameters) => ({
        url: `serieEmpresa`,
        method: "POST",
        body: parameters,
      }),
      invalidatesTags: ["reloadTable"],
    }),
  }),
});

export const { useCreateSerieMutation } = creserxxApiSlice;
export const { useUpdateSerieMutation } = creserxxApiSlice;
export const { useUpdateCompanyAreaSerieMutation } = creserxxApiSlice;
export const { useCreateCompanyAreaSerieMutation } = creserxxApiSlice;
